/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
  name: "ScheduleCyclePopUp",
  props: {
    patientid: String,
    cycleid: Number,
    occurence: {
      type: Number,
      default: 0,
    }
    },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      cycleoccurence:0,
      patientId: this.patientid,
      cycleId: this.cycleid,

      cycleData: {},
      subjectcycledata:{},

      cycleForm: {
        startDate: "",
        endDate: ""
      },

      cycleErrors: {
        startDate: false
      },

      isCreating: false,

      today: new Date().toISOString().split("T")[0]
    };
  },

  async mounted() {
    this.cycleoccurence = this.occurence;
    await this.getCycleData();
    await this.getsubjectcyclerecord();
  },

  methods: {
    calculateEndDateFromDuration(startDate, durationDays) {
      if (!startDate) return "";

      const parsedDuration = parseInt(durationDays, 10);
      const safeDuration = Number.isFinite(parsedDuration) && parsedDuration >= 0 ? parsedDuration : 0;

      const start = new Date(`${startDate}T00:00:00`);
      if (Number.isNaN(start.getTime())) return "";

      start.setDate(start.getDate() + safeDuration);
      return start.toISOString().split("T")[0];
    },
    onStartDateChange() {
      this.cycleErrors.startDate = !this.cycleForm.startDate;
      if (this.cycleErrors.startDate) return;

      this.cycleForm.endDate = this.calculateEndDateFromDuration(
        this.cycleForm.startDate,
        this.cycleData?.cycleDuration
      );
    },
    async getsubjectcyclerecord() {
      try {
        const currentstudy = store.getters.getStudyIs;
        const response = await axios.get(
          `${this.baseurl}/management/cycle/getsubjectcyclerecord?subjectId=${this.patientid}&cycleId=${this.cycleId}&occurrence=${this.occurence}`,
          {
            headers: {
              Authorization: "Bearer " + store.getters.getIdToken,
              "Content-Type": "application/json"
            }
          }
        );
        this.subjectcycledata = response.data;
        console.log("response.data",response.data);
        this.cycleForm.startDate = this.subjectcycledata.cycleStartDate?.split("T")[0] || "";
        this.cycleForm.endDate = this.subjectcycledata.cycleEndDate?.split("T")[0] || "";

      } catch (err) {
        console.error("Error fetching cycle data:", err);
      }
    },
    async getCycleData() {
      try {
        const currentstudy = store.getters.getStudyIs;
        const response = await axios.get(
          `${this.baseurl}/management/cycle/getcyclebycycleid?cycleId=${this.cycleId}&studyId=${currentstudy}`,
          {
            headers: {
              Authorization: "Bearer " + store.getters.getIdToken,
              "Content-Type": "application/json"
            }
          }
        );
        this.cycleData = response.data;
      } catch (err) {
        console.error("Error fetching cycle data:", err);
      }
    },
    async closeModal() {
      this.$emit("closeModal");
      
    },
    async createSchedule() {
      if (this.isCreating) return;

      this.cycleErrors.startDate = !this.cycleForm.startDate;
      if (this.cycleErrors.startDate) return;

      function toUTCDateOnlyISO(dateStr) {
        if (!dateStr) return null;
        const d = new Date(dateStr);
        const utcMidnight = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        return utcMidnight.toISOString(); 
      }

      const payload = {
        subjectId: this.patientId,
        cycleId: this.cycleData.cycleId,
        studyId: store.getters.getStudyIs,
        occurence: this.occurence,
        cycleStartDate: toUTCDateOnlyISO(this.cycleForm.startDate),
        cycleEndDate:   toUTCDateOnlyISO(this.cycleForm.endDate) 
      };

      console.log("payload being sent", payload);

      try {
        this.isCreating = true;
        const response = await axios.put(
          `${this.baseurl}/management/patientschedule/schedulecycleupdate`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + store.getters.getIdToken,
              "Content-Type": "application/json"
            }
          }
        );

        alert("Cycle updated successfully");
        this.$emit("cycleScheduled", {
          patientId: this.patientId,
          cycleId: this.cycleId
        });
        this.$emit("closeModal");
      } catch (err) {
          const message =
          err?.response?.data?.detail ||
          'Something went wrong';

          alert(message);
        } finally {
          this.isCreating = false;
        }
    }
  }
};
